import { autoSizeColumn, createXlsx } from "src/utils/createXlsx"
import * as XLSX from "xlsx-js-style"

export const createFaceImportTemplate = conjunto => {
  const wb = XLSX.utils.book_new()

  // =================== HOJA 1: INSTRUCCIONES ===================
  const instructionsData = [
    ["INSTRUCCIONES PARA IMPORTACIÓN DE ROSTROS"],
    [],
    ["FORMATO DEL ARCHIVO:"],
    ['• Use únicamente la hoja "Rostros" para ingresar los datos'],
    ["• No modifique las primeras 4 filas (títulos y encabezados)"],
    ["• Ingrese los datos a partir de la fila 5"],
    ["• Todas las filas vacías serán ignoradas"],
    [],
    ["CAMPOS OBLIGATORIOS:"],
    ["• Nombres: Texto completo del nombre de la persona"],
    ["• Identificacion: Solo números, sin puntos, guiones o espacios"],
    [],
    ["CAMPOS OPCIONALES:"],
    ["• Unidad Hab.: Número o código de la unidad habitacional registrada"],
    [
      "• Pisos: Números de pisos separados por comas (Ej: -2,-1,1,4,8,9). Negativos para subsuelos",
    ],
    ["• Tipo: Tipo de persona según las opciones válidas"],
    ["• Estado: Estado de acceso de la persona"],
    ["• Nombre de Imagen: Nombre del archivo de imagen del rostro"],
    ["• Observaciones: Comentarios adicionales"],
    [],
    ["FORMATOS ESPECÍFICOS:"],
    [],
    ["IDENTIFICACIÓN:"],
    ["✓ Correcto: 1234567890"],
    ["✗ Incorrecto: 12.345.678-9, 12-345-678, 12 345 678"],
    [],
    ["UNIDAD HABITACIONAL:"],
    ["✓ Ejemplos válidos: A12, B05, 15, 10, C103, 204"],
    ["✓ Puede ser: números (15, 10, 204) o letras con números (A12, B05)"],
    [
      "⚠️ Importante: La unidad debe estar previamente registrada en el sistema",
    ],
    [],
    ["TIPO DE PERSONA:"],
    ["Opciones válidas (escriba exactamente como se muestra):"],
    ["• propietario"],
    ["• familiar"],
    ["• empleado"],
    ["• visitante"],
    ["• inquilino"],
    ["• arrendatario"],

    [],
    ["ESTADO:"],
    ["Opciones válidas (escriba exactamente como se muestra):"],
    ["• activo (predeterminado si se deja vacío)"],
    ["• bloqueado"],
    [],
    [],
    ["PIN DE ACCESO:"],
    ["✓ Opcional — entre 4 y 8 dígitos numéricos"],
    ["✓ Ejemplo: 1234, 56789"],
    ["⚠️ Si se deja vacío, no se asignará PIN"],
    [],
    ["TAGS (NFC/RFID):"],
    ["✓ Opcional — códigos de tarjetas NFC o RFID"],
    ["✓ Separe múltiples códigos con coma: ABC123, DEF456"],
    ["⚠️ Si se deja vacío, no se asignarán TAGs"],
    [],
    ["QRS:"],
    ["✓ Opcional — códigos QR de acceso"],
    ["✓ Separe múltiples códigos con coma: QR001, QR002"],
    ["⚠️ Si se deja vacío, no se asignarán QRs"],
    ["EJEMPLOS DE DATOS VÁLIDOS:"],
    [],
    [
      "Nombres           | Identificacion | Unidad Hab. | Pisos     | Tipo       | Estado  | Control Asist. | Nombre Imagen     | Observaciones",
    ],
    [
      "Juan Pérez García | 1234567890     | A12         | -2,-1,1,4 | propietario| activo  | si             | juan_perez.jpg    | Propietario principal",
    ],
    [],
    ["NOMBRE DE IMAGEN:"],
    ["✓ Ejemplos válidos: persona1, rostro_123, foto"],
    ["✓ Formatos aceptados: jpg, jpeg, png"],
    ["⚠️ Opcional: Si no se especifica, no se asociará imagen al rostro"],
    [],
    ["CONTROL DE ASISTENCIA:"],
    ["Opciones válidas (escriba exactamente como se muestra):"],
    ["• si (para activar el control de asistencia)"],
    ["• no (para desactivar el control de asistencia - predeterminado)"],
    ["⚠️ Si se deja vacío, se asignará 'no' por defecto"],
    ["NOTAS IMPORTANTES:"],
    ['• Si no especifica el tipo, se asignará "propietario" por defecto'],
    ['• Si no especifica el estado, se asignará "activo" por defecto'],
    [
      "• Las unidades habitacionales deben existir en el sistema antes de la importación",
    ],
    ["• La identificación debe ser única para cada persona"],
    ["• El proceso validará todos los datos antes de la importación"],
    [],
    ["ERRORES COMUNES:"],
    ["• Dejar campos obligatorios vacíos"],
    ["• Usar tipos o estados no válidos"],
    ["• Ingresar identificaciones con caracteres especiales"],
    ["• Referenciar unidades habitacionales no registradas en el sistema"],
    [],
    ["PROCESO DE IMPORTACIÓN:"],
    ['1. Complete los datos en la hoja "Rostros"'],
    ["2. Guarde el archivo"],
    ["3. Suba el archivo al sistema"],
    ["4. Revise el reporte de validación"],
    ["5. Corrija cualquier error reportado"],
    ["6. Confirme la importación"],
  ]

  const wsInstructions = XLSX.utils.aoa_to_sheet(instructionsData)

  wsInstructions.A1.s = {
    fill: { fgColor: { rgb: "092147" } },
    font: { color: { rgb: "FFFFFFFF" }, bold: true, sz: 16 },
    alignment: { horizontal: "center" },
  }

  if (!wsInstructions["!merges"]) wsInstructions["!merges"] = []
  wsInstructions["!merges"].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 5 } })

  const sectionTitleRows = [2, 8, 12, 18, 20, 24, 29, 36, 41, 43, 49, 56, 62]
  sectionTitleRows.forEach(rowIndex => {
    const cellAddress = XLSX.utils.encode_cell({ c: 0, r: rowIndex })
    if (wsInstructions[cellAddress]) {
      wsInstructions[cellAddress].s = {
        fill: { fgColor: { rgb: "4472C4" } },
        font: { color: { rgb: "FFFFFFFF" }, bold: true },
        alignment: { horizontal: "left" },
      }
    }
  })

  // Auto-ajustar columnas para instrucciones
  autoSizeColumn(wsInstructions)

  // =================== HOJA 2: ROSTROS (DATOS) ===================
  const headers = [
    "Nombres",
    "Identificacion",
    "Unidad Hab.",
    "Pisos",
    "Tipo",
    "Estado",
    "PIN",
    "TAGs",
    "QRs",
    "Nombre de Imagen",
    "Observaciones",
  ]

  const headerCustom = [
    [conjunto.Nombre],
    ["Plantilla de Importación de Rostros"],
    [],
    headers,
  ]

  const ws = XLSX.utils.aoa_to_sheet(headerCustom)

  const mergeConjunto = {
    s: { r: 0, c: 0 },
    e: { r: 0, c: headers.length - 1 },
  }
  const mergeReporte = {
    s: { r: 1, c: 0 },
    e: { r: 1, c: headers.length - 1 },
  }

  if (!ws["!merges"]) ws["!merges"] = []
  ws["!merges"].push(mergeConjunto)
  ws["!merges"].push(mergeReporte)

  for (let i = 0; i < 2; i++) {
    const cellAddress1 = XLSX.utils.encode_cell({ c: 0, r: i })
    ws[cellAddress1].s = {
      fill: {
        fgColor: { rgb: "092147" },
      },
      font: {
        color: { rgb: "FFFFFFFF" },
        bold: true,
      },
      alignment: {
        horizontal: "center",
      },
    }
  }

  for (let col = 0; col < headers.length; col++) {
    const cellAddress = XLSX.utils.encode_cell({ c: col, r: 3 })
    ws[cellAddress].s = {
      fill: {
        fgColor: { rgb: "092147" },
      },
      font: {
        color: { rgb: "FFFFFFFF" },
        bold: true,
      },
      border: {
        top: { style: "thin", color: { auto: 1 } },
        bottom: { style: "thin", color: { auto: 1 } },
        left: { style: "thin", color: { auto: 1 } },
        right: { style: "thin", color: { auto: 1 } },
      },
      alignment: {
        horizontal: "center",
      },
    }
  }

  // Auto-ajustar columnas
  autoSizeColumn(ws)

  const pisosColIndex = headers.indexOf("Pisos")
  if (pisosColIndex !== -1) {
    for (let row = 4; row <= 1004; row++) {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: pisosColIndex })

      // Crear celda con formato de texto
      ws[cellAddress] = {
        t: "s", // tipo string
        v: "", // valor vacío
        z: "@", // formato texto
      }
    }

    if (!ws["!cols"]) ws["!cols"] = []
    ws["!cols"][pisosColIndex] = { wch: 20 }
  }

  XLSX.utils.book_append_sheet(wb, wsInstructions, "Instrucciones")
  XLSX.utils.book_append_sheet(wb, ws, "Rostros")

  XLSX.writeFile(wb, `${conjunto.Nombre} - Plantilla Rostros.xlsx`)
}

export const processFaceImportFile = async file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = e => {
      try {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: "array" })

        const [firstSheetName] = workbook.SheetNames
        const worksheetName = workbook.Sheets.Rostros
          ? "Rostros"
          : firstSheetName

        const worksheet = workbook.Sheets[worksheetName]

        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: "",
        })

        if (jsonData.length < 4) {
          reject(
            new Error(
              "El archivo no tiene el formato esperado. Debe tener al menos 4 filas (títulos + encabezados)."
            )
          )
          return
        }

        const headers = jsonData[3]

        const requiredHeaders = ["nombres", "identificacion"]
        const hasRequiredHeaders = requiredHeaders.every(reqHeader =>
          headers.some(
            header =>
              header &&
              header
                .toString()
                .toLowerCase()
                .trim()
                .includes(reqHeader.toLowerCase())
          )
        )

        if (!hasRequiredHeaders) {
          let foundHeaderRow = -1
          for (let i = 0; i < jsonData.length; i++) {
            const row = jsonData[i]
            const hasHeaders = requiredHeaders.every(reqHeader =>
              row.some(
                cell =>
                  cell &&
                  cell
                    .toString()
                    .toLowerCase()
                    .trim()
                    .includes(reqHeader.toLowerCase())
              )
            )
            if (hasHeaders) {
              foundHeaderRow = i
              break
            }
          }

          if (foundHeaderRow === -1) {
            reject(
              new Error(
                'El archivo no tiene el formato correcto. Debe incluir columnas: "Nombres", "Identificacion"'
              )
            )
            return
          }
          jsonData[3] = jsonData[foundHeaderRow]
        }

        const columnIndexes = {}
        headers.forEach((header, index) => {
          if (header) {
            const normalizedHeader = header.toString().toLowerCase().trim()
            if (normalizedHeader.includes("nombre"))
              columnIndexes.nombres = index

            if (normalizedHeader === "pin") columnIndexes.pin = index
            if (normalizedHeader.includes("tag")) columnIndexes.tags = index
            if (normalizedHeader.includes("qr")) columnIndexes.qrs = index
            if (normalizedHeader.includes("identificaci"))
              columnIndexes.identificacion = index
            if (
              normalizedHeader.includes("unidad") ||
              normalizedHeader.includes("hab")
            )
              columnIndexes.unidad = index
            if (normalizedHeader.includes("pisos")) columnIndexes.pisos = index
            if (normalizedHeader.includes("tipo")) columnIndexes.tipo = index
            if (normalizedHeader.includes("estado"))
              columnIndexes.estado = index
            if (normalizedHeader.includes("observ"))
              columnIndexes.observaciones = index
            if (normalizedHeader.includes("imagen"))
              columnIndexes.imagen = index
          }
        })

        const isEmptyRow = row =>
          !row || row.every(cell => !cell || cell.toString().trim() === "")

        const processedData = []
        const errors = []

        for (let i = 4; i < jsonData.length; i++) {
          const row = jsonData[i]

          if (!isEmptyRow(row)) {
            const rowData = {}
            const rowErrors = []

            rowData.nombre = row[columnIndexes.nombres]
              ? row[columnIndexes.nombres].toString().trim()
              : ""
            rowData.identificacion = row[columnIndexes.identificacion]
              ? row[columnIndexes.identificacion].toString().trim()
              : ""
            rowData.destino = row[columnIndexes.unidad]
              ? row[columnIndexes.unidad].toString().trim()
              : ""
            rowData.pisos = row[columnIndexes.pisos]
              ? (() => {
                  const pisosString = row[columnIndexes.pisos]
                    .toString()
                    .replace(/^['"]/, "")
                    .replace(/\s+/g, "")
                    .toUpperCase()

                  return pisosString
                    .split(",")
                    .map(p => {
                      const trimmed = p.trim()
                      const subsuelo = trimmed.match(/^S(\d+)$/)
                      if (subsuelo) {
                        const numero = parseInt(subsuelo[1], 10)
                        return -numero
                      }

                      const num = parseInt(trimmed, 10)
                      return Number.isNaN(num) ? null : num
                    })
                    .filter(p => p !== null)
                })()
              : []
            rowData.tipo = row[columnIndexes.tipo]
              ? row[columnIndexes.tipo].toString().trim()
              : "propietario"
            rowData.estado = row[columnIndexes.estado]
              ? row[columnIndexes.estado].toString().trim()
              : "activo"
            rowData.observaciones = row[columnIndexes.observaciones]
              ? row[columnIndexes.observaciones].toString().trim()
              : ""
            rowData.imagen = row[columnIndexes.imagen]
              ? row[columnIndexes.imagen].toString().trim()
              : ""

            rowData.pin = row[columnIndexes.pin]
              ? row[columnIndexes.pin]
                  .toString()
                  .replace(/\D/g, "")
                  .substring(0, 8)
              : ""

            if (
              rowData.pin &&
              (rowData.pin.length < 4 || rowData.pin.length > 8)
            ) {
              rowErrors.push("PIN debe tener entre 4 y 8 dígitos")
            }

            const parseCodes = (raw, tipo) => {
              if (!raw) return []
              return raw
                .toString()
                .split(",")
                .map(s => s.replace(/[^\x20-\x7E]/g, "").trim())
                .filter(s => s.length > 0)
                .map(codigo => ({ tipo, codigo, label: "" }))
            }

            rowData.tarjeta = [
              ...parseCodes(row[columnIndexes.tags], "tag"),
              ...parseCodes(row[columnIndexes.qrs], "qr"),
            ]

            if (!rowData.nombre) {
              rowErrors.push("Nombres es requerido")
            }

            if (!rowData.identificacion) {
              rowErrors.push("Identificacion es requerida")
            } else {
              if (!rowData.identificacion) {
                rowErrors.push("Identificacion es requerida")
              }

              if (
                rowData.identificacion &&
                !/^\d+$/.test(rowData.identificacion)
              ) {
                rowErrors.push(
                  "Identificacion debe contener solo números (sin puntos, guiones o espacios)"
                )
              }
            }

            if (rowData.destino) {
              rowData.destino = rowData.destino.toString().trim()
            }

            const validTypes = [
              "propietario",
              "familiar",
              "empleado",
              "visitante",
              "arrendatario",
              "inquilino",
            ]
            if (
              rowData.tipo &&
              !validTypes.includes(rowData.tipo.toLowerCase())
            ) {
              rowErrors.push(
                `Tipo '${rowData.tipo}' no es válido. Use: ${validTypes.join(
                  ", "
                )}`
              )
            } else if (rowData.tipo) {
              rowData.tipo = rowData.tipo.toLowerCase()
            }

            const validStates = ["activo", "bloqueado"]
            if (
              rowData.estado &&
              !validStates.includes(rowData.estado.toLowerCase())
            ) {
              rowErrors.push(
                `Estado '${
                  rowData.estado
                }' no es válido. Use: ${validStates.join(", ")}`
              )
            } else if (rowData.estado) {
              rowData.estado = rowData.estado.toLowerCase()
            }

            if (rowErrors.length > 0) {
              errors.push({
                row: i + 1,
                errors: rowErrors,
                data: rowData,
              })
            } else {
              processedData.push(rowData)
            }
          }
        }

        if (processedData.length === 0 && errors.length === 0) {
          resolve({
            success: true,
            data: [],
            errors: [],
            totalRows: 0,
            validRows: 0,
            invalidRows: 0,
            message:
              "Archivo procesado correctamente pero no contiene datos para importar",
          })
          return
        }

        resolve({
          success: true,
          data: processedData,
          errors,
          totalRows: processedData.length + errors.length,
          validRows: processedData.length,
          invalidRows: errors.length,
        })
      } catch (error) {
        reject(new Error(`Error al procesar el archivo: ${error.message}`))
      }
    }

    reader.onerror = () => {
      reject(new Error("Error al leer el archivo"))
    }

    reader.readAsArrayBuffer(file)
  })

export const generateErrorReport = (errors, conjunto) => {
  if (!errors || errors.length === 0) return

  const errorData = errors.map(error => ({
    fila: error.row,
    errores: error.errors.join("; "),
    nombre: error.data?.nombre || "",
    identificacion: error.data?.identificacion || "",
    imagen: error.data?.imagen || "",
    observaciones: "Error de conexión",
  }))

  const sheets = [
    {
      name: "Reporte de Errores",
      sheet: "Errores",
      table: errorData,
      columns: [],
    },
  ]

  createXlsx(sheets, {
    Nombre: `${conjunto.Nombre} - Errores Importación`,
  })
}
